var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect2, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _rect3, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLangKurzWaffen = function SvgLangKurzWaffen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.815,
    height: 90.554
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lang_kurz-waffen_svg__b",
    x1: 4.822,
    x2: 27.676,
    y1: 34.379,
    y2: 31.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0996c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0996c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lang_kurz-waffen_svg__c",
    x1: 5.086,
    x2: 30.33,
    y1: 34.17,
    y2: 32.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bca371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bca371",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lang_kurz-waffen_svg__a",
    x1: 67.66,
    x2: 75.859,
    y1: 27.491,
    y2: 28.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__a",
    id: "lang_kurz-waffen_svg__d",
    x1: 35.762,
    x2: 44.089,
    y1: 28.144,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__b",
    id: "lang_kurz-waffen_svg__e",
    x1: 4.822,
    x2: 27.676,
    y1: 59.178,
    y2: 56.787
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__c",
    id: "lang_kurz-waffen_svg__f",
    x1: 5.086,
    x2: 30.33,
    y1: 58.969,
    y2: 57.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__a",
    id: "lang_kurz-waffen_svg__g",
    x1: 67.66,
    x2: 75.859,
    y1: 52.29,
    y2: 53.491
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__a",
    id: "lang_kurz-waffen_svg__h",
    x1: 35.762,
    x2: 44.089,
    y1: 52.942,
    y2: 52.298
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__b",
    id: "lang_kurz-waffen_svg__i",
    x1: 4.822,
    x2: 27.676,
    y1: 83.977,
    y2: 81.586
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__c",
    id: "lang_kurz-waffen_svg__j",
    x1: 5.086,
    x2: 30.33,
    y1: 83.768,
    y2: 81.988
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__a",
    id: "lang_kurz-waffen_svg__k",
    x1: 67.66,
    x2: 75.859,
    y1: 77.089,
    y2: 78.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#lang_kurz-waffen_svg__a",
    id: "lang_kurz-waffen_svg__l",
    x1: 35.762,
    x2: 44.089,
    y1: 77.741,
    y2: 77.097
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M32.982 0h4.744v4.744h-4.744z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f4c50",
    d: "M40.507 0h4.744v4.744h-4.744z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#365d61",
    d: "M48.031 0h4.744v4.744h-4.744z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M55.556 0H60.3v4.744h-4.744z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m7.504 40.625-6.137-.719A1.547 1.547 0 0 1 0 38.37v-6.543A1.55 1.55 0 0 1 1.299 30.3l5.305-.862a1.547 1.547 0 0 1 1.787 1.37l.831 8.123a1.547 1.547 0 0 1-1.718 1.694"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f4c50",
    d: "m0 36.439 8.922-.443-.436-4.266L0 32.151z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#365d61",
    d: "m0 35.153 8.791-.436-.218-2.134L0 33.008z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m41.346 37.502-.635.029.009.199a.22.22 0 0 1-.209.228l-.919.042a.22.22 0 0 1-.228-.208l-.009-.2-.635.03.009.199a.22.22 0 0 1-.209.228l-.919.042a.22.22 0 0 1-.228-.208l-.009-.2-.635.03.009.199a.22.22 0 0 1-.208.228l-.92.042a.22.22 0 0 1-.228-.208l-.009-.2-.635.03.01.199a.22.22 0 0 1-.21.228l-.918.042a.22.22 0 0 1-.228-.209l-.01-.198-.328.015-.19-4.169 8.292-.378Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.391 30.808a1.547 1.547 0 0 0-1.787-1.37l-3.107.505v5.75a2.317 2.317 0 0 0 2.07 2.306l3.6.398Z",
    opacity: 0.15
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#a59067",
    d: "m16.393 29.366-.836-1.025a1.25 1.25 0 0 0-1.077-.455l-8.773.773a1.25 1.25 0 0 0-1.139 1.243v5.79a1.25 1.25 0 0 0 1.114 1.242l8.375.905a1.25 1.25 0 0 1 .586.221l2.895 2.045a1.25 1.25 0 0 0 .594.222l6.143.623a1.25 1.25 0 0 0 1.322-.886l2.053-6.911a1.3 1.3 0 0 0 .052-.355V29.38l-10.288.445a1.25 1.25 0 0 1-1.021-.459m5.225 8.015a2.236 2.236 0 0 1-2.388-1.982 3.29 3.29 0 0 1 2.795-2.666c1.179 0 1.735 1.317 1.735 2.506a2.14 2.14 0 0 1-2.142 2.142"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M29.34 35.353a.51.51 0 0 1-.453-.276c-.042-.08-1.431-2.075-.67-3.84.113-.258 2.435.386 2.221.57a2.76 2.76 0 0 0-.645 2.802.51.51 0 0 1-.453.744"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#a59067",
    d: "M63.152 29.102v3.117l-18.024.44a.6.6 0 0 0-.227.051l-5.463 2.368a.6.6 0 0 1-.451.013l-3.048-1.116a.61.61 0 0 0-.59.097l-1.62 1.299a.61.61 0 0 1-.868-.109l-1.805-2.397a.6.6 0 0 0-.403-.237l-2.951-.41v-3.116Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m31.695 33.713-.629 1.595a.704.704 0 0 1-.718.443l-1.541-.14a.8.8 0 0 1-.494-.228l-1.028-1-.521 1.753.766.66a.8.8 0 0 0 .488.196l2.975.158a1.27 1.27 0 0 0 1.182-.666l.669-1.245ZM38.987 35.091l-.33-.12q-.002.053-.002.108a7.5 7.5 0 0 0 .363 2.072 7.3 7.3 0 0 0 .171-2.027.6.6 0 0 1-.202-.033M36.753 34.273q-.024.462-.01.923a7.5 7.5 0 0 0 .362 2.072 7.5 7.5 0 0 0 .172-2.097c-.015-.245-.046-.49-.075-.734ZM34.62 34.656c-.006.237-.015.473-.008.709a7.5 7.5 0 0 0 .362 2.072 7.5 7.5 0 0 0 .173-2.097c-.021-.34-.052-.682-.106-1.021Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__b)",
    d: "m27.007 35.317.643-2.164a1.3 1.3 0 0 0 .052-.355v-2.88l-23.134 1.23v4.545a1.24 1.24 0 0 0 .3.8l14.404-.765a1.7 1.7 0 0 1-.042-.329 3.29 3.29 0 0 1 2.795-2.666c1.179 0 1.735 1.317 1.735 2.506a2 2 0 0 1-.025.252Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__c)",
    d: "M27.702 30.775 4.568 32.006v3.218l14.97-.796a3.4 3.4 0 0 1 2.487-1.695c.837 0 1.354.667 1.588 1.478l3.783-.201.254-.857a1.3 1.3 0 0 0 .052-.355v-.58l2.951.41a.6.6 0 0 1 .403.237l.8 1.063 10.69-.197L44.9 32.71a.6.6 0 0 1 .227-.05l18.024-.441v-1.444Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.152 29.102h-35.45v.278l-1.002.044a1.19 1.19 0 0 0 1.11.86l18.563.527a1.22 1.22 0 0 0 1.065-.633l15.714.27Z",
    opacity: 0.15
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#021819",
    d: "M34.336 24.675H42v2.156h-7.664z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m89.54 29.832-43.274-.744a.14.14 0 0 1-.14-.142v-1.76a.14.14 0 0 1 .142-.142l43.275-.213a.14.14 0 0 1 .142.142v2.717a.14.14 0 0 1-.144.142"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m95.663 30.58-5.845-.408a.14.14 0 0 1-.133-.142v-3.5a.14.14 0 0 1 .135-.141l5.845-.307a.14.14 0 0 1 .15.142v4.215a.14.14 0 0 1-.152.141M25.81 25.111l5.424.41a.12.12 0 0 0 .13-.12v-3.146a.12.12 0 0 0-.13-.121l-5.424.41a.12.12 0 0 0-.112.121v2.325a.12.12 0 0 0 .112.121M45.522 25.082l2.632.923a.1.1 0 0 0 .047.008h7.872a.14.14 0 0 0 .142-.142v-4.086a.14.14 0 0 0-.142-.142h-7.872a.1.1 0 0 0-.047.008l-2.632.922a.14.14 0 0 0-.095.134v2.241a.14.14 0 0 0 .095.134"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.062,
    height: 2.442,
    x: 31.365,
    y: 22.607,
    fill: "#093a3e",
    rx: 0.133
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m46.37 29.74-18.53-.527a.14.14 0 0 1-.138-.142v-2.284a.14.14 0 0 1 .138-.142l18.53-.527a.14.14 0 0 1 .145.142v3.338a.14.14 0 0 1-.146.142"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.306 32.733c-.045 0-.094.016-.14.02 1.077.105 1.595 1.348 1.595 2.486a2.14 2.14 0 0 1-2.142 2.142 2.27 2.27 0 0 1-2.37-1.833c-.003.039-.019.08-.019.12a2.46 2.46 0 0 0 2.628 2.18 2.356 2.356 0 0 0 2.357-2.357c0-1.309-.612-2.758-1.909-2.758",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__a)",
    d: "m67.594 29.455 8.886.153a2.5 2.5 0 0 1 .56-2.716l-8.006.04c.247.178.437.351.454.503.086.792-.86 1.444-1.894 2.02",
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__d)",
    d: "M39.75 29.552a3.21 3.21 0 0 1 .21-3.252l-4.056.116c.785.757 1.868 2.025 1.642 3.073Z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#55767a",
    d: "m25.698 24.047 5.667.201v-.84l-5.667.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f7e82",
    d: "m25.698 23.897 5.667.134v-.407l-5.667.134z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#55767a",
    d: "m45.427 24.746 10.788.382v-2.6l-10.788.382z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f7e82",
    d: "m45.427 24.363 10.788.255v-1.58l-10.788.254z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "M32.564 27.31c2.257-.175 4.518-.247 6.777-.327 2.261-.049 4.522-.106 6.786-.059-2.258.176-4.518.247-6.778.327-2.26.048-4.521.105-6.785.06"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m7.504 65.423-6.137-.718A1.547 1.547 0 0 1 0 63.168v-6.542a1.55 1.55 0 0 1 1.299-1.527l5.305-.862a1.547 1.547 0 0 1 1.787 1.37l.831 8.122a1.547 1.547 0 0 1-1.718 1.694"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f4c50",
    d: "m0 61.238 8.922-.443-.436-4.267L0 56.949z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#365d61",
    d: "m0 59.952 8.791-.436-.218-2.135L0 57.806z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m41.346 62.3-.635.03.009.199a.22.22 0 0 1-.209.228l-.919.042a.22.22 0 0 1-.228-.209l-.009-.198-.635.029.009.198a.22.22 0 0 1-.209.229l-.919.042a.22.22 0 0 1-.228-.209l-.009-.199-.635.03.009.198a.22.22 0 0 1-.208.229l-.92.042a.22.22 0 0 1-.228-.209l-.009-.199-.635.03.01.198a.22.22 0 0 1-.21.228l-.918.042a.22.22 0 0 1-.228-.208l-.01-.199-.328.015-.19-4.168 8.292-.379Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.391 55.607a1.547 1.547 0 0 0-1.787-1.37l-3.107.505v5.749a2.317 2.317 0 0 0 2.07 2.306l3.6.399Z",
    opacity: 0.15
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#a59067",
    d: "m16.393 54.165-.836-1.026a1.25 1.25 0 0 0-1.077-.455l-8.773.774A1.25 1.25 0 0 0 4.568 54.7v5.79a1.25 1.25 0 0 0 1.114 1.241l8.375.905a1.25 1.25 0 0 1 .586.222l2.895 2.044a1.25 1.25 0 0 0 .594.223l6.143.623a1.25 1.25 0 0 0 1.322-.887l2.053-6.91a1.3 1.3 0 0 0 .052-.356V54.18l-10.288.444a1.25 1.25 0 0 1-1.021-.458m5.225 8.015a2.236 2.236 0 0 1-2.388-1.982 3.29 3.29 0 0 1 2.795-2.667c1.179 0 1.735 1.318 1.735 2.507a2.14 2.14 0 0 1-2.142 2.142"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M29.34 60.151a.51.51 0 0 1-.453-.275c-.042-.081-1.431-2.076-.67-3.84.113-.258 2.435.386 2.221.57a2.76 2.76 0 0 0-.645 2.802.51.51 0 0 1-.453.743"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#a59067",
    d: "M63.152 53.9v3.117l-18.024.441a.6.6 0 0 0-.227.05l-5.463 2.369a.6.6 0 0 1-.451.013l-3.048-1.116a.61.61 0 0 0-.59.097l-1.62 1.299a.61.61 0 0 1-.868-.11l-1.805-2.396a.6.6 0 0 0-.403-.237l-2.951-.41v-3.116Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m31.695 58.512-.629 1.595a.704.704 0 0 1-.718.443l-1.541-.14a.8.8 0 0 1-.494-.228l-1.028-1-.521 1.753.766.66a.8.8 0 0 0 .488.196l2.975.157a1.27 1.27 0 0 0 1.182-.665l.669-1.245ZM38.987 59.89l-.33-.121q-.002.054-.002.109a7.5 7.5 0 0 0 .363 2.072 7.3 7.3 0 0 0 .171-2.028.6.6 0 0 1-.202-.032M36.753 59.072q-.024.462-.01.922a7.5 7.5 0 0 0 .362 2.072 7.5 7.5 0 0 0 .172-2.096c-.015-.245-.046-.49-.075-.734ZM34.62 59.455c-.006.236-.015.473-.008.708a7.5 7.5 0 0 0 .362 2.073 7.5 7.5 0 0 0 .173-2.097c-.021-.341-.052-.682-.106-1.022Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__e)",
    d: "m27.007 60.115.643-2.163a1.3 1.3 0 0 0 .052-.356v-2.88l-23.134 1.23v4.545a1.24 1.24 0 0 0 .3.801l14.404-.766a1.7 1.7 0 0 1-.042-.328 3.29 3.29 0 0 1 2.795-2.667c1.179 0 1.735 1.318 1.735 2.507a2 2 0 0 1-.025.251Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__f)",
    d: "m27.702 55.574-23.134 1.23v3.219l14.97-.797a3.4 3.4 0 0 1 2.487-1.695c.837 0 1.354.668 1.588 1.479l3.783-.202.254-.856a1.3 1.3 0 0 0 .052-.356v-.579l2.951.41a.6.6 0 0 1 .403.237l.8 1.062 10.69-.197 2.355-1.02a.6.6 0 0 1 .227-.05l18.024-.442v-1.443Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.152 53.9h-35.45v.28l-1.002.042a1.19 1.19 0 0 0 1.11.86l18.563.528a1.22 1.22 0 0 0 1.065-.633l15.714.27Z",
    opacity: 0.15
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#021819",
    d: "M34.336 49.473H42v2.156h-7.664z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m89.54 54.631-43.274-.745a.14.14 0 0 1-.14-.142v-1.76a.14.14 0 0 1 .142-.142l43.275-.212a.14.14 0 0 1 .142.142v2.717a.14.14 0 0 1-.144.142"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m95.663 55.379-5.845-.409a.14.14 0 0 1-.133-.141v-3.5a.14.14 0 0 1 .135-.142l5.845-.306a.14.14 0 0 1 .15.142v4.214a.14.14 0 0 1-.152.142M25.81 49.91l5.424.41a.12.12 0 0 0 .13-.12v-3.146a.12.12 0 0 0-.13-.121l-5.424.41a.12.12 0 0 0-.112.12v2.326a.12.12 0 0 0 .112.121M45.522 49.88l2.632.923a.1.1 0 0 0 .047.008h7.872a.14.14 0 0 0 .142-.142v-4.086a.14.14 0 0 0-.142-.142h-7.872a.1.1 0 0 0-.047.008l-2.632.923a.14.14 0 0 0-.095.134v2.24a.14.14 0 0 0 .095.135"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.062,
    height: 2.442,
    x: 31.365,
    y: 47.405,
    fill: "#093a3e",
    rx: 0.133
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m46.37 54.54-18.53-.528a.14.14 0 0 1-.138-.142v-2.284a.14.14 0 0 1 .138-.142l18.53-.528a.14.14 0 0 1 .145.142v3.339a.14.14 0 0 1-.146.142"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.306 57.531c-.045 0-.094.017-.14.02 1.077.105 1.595 1.348 1.595 2.487a2.14 2.14 0 0 1-2.142 2.142 2.27 2.27 0 0 1-2.37-1.834c-.003.04-.019.081-.019.12a2.46 2.46 0 0 0 2.628 2.18 2.356 2.356 0 0 0 2.357-2.357c0-1.308-.612-2.758-1.909-2.758",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__g)",
    d: "m67.594 54.253 8.886.153a2.5 2.5 0 0 1 .56-2.715l-8.006.04c.247.178.437.351.454.502.086.792-.86 1.444-1.894 2.02",
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__h)",
    d: "M39.75 54.35a3.21 3.21 0 0 1 .21-3.251l-4.056.115c.785.757 1.868 2.025 1.642 3.074Z",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#55767a",
    d: "m25.698 48.846 5.667.2v-.84l-5.667.201z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f7e82",
    d: "m25.698 48.696 5.667.134v-.407l-5.667.134z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#55767a",
    d: "m45.427 49.544 10.788.382v-2.6l-10.788.382z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f7e82",
    d: "m45.427 49.162 10.788.255v-1.581l-10.788.255z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "M32.564 52.109c2.257-.175 4.518-.247 6.777-.327 2.261-.049 4.522-.106 6.786-.06-2.258.176-4.518.248-6.778.327-2.26.05-4.521.106-6.785.06"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m7.504 90.222-6.137-.719A1.547 1.547 0 0 1 0 87.967v-6.543a1.55 1.55 0 0 1 1.299-1.526l5.305-.862a1.547 1.547 0 0 1 1.787 1.37l.831 8.122a1.547 1.547 0 0 1-1.718 1.694"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f4c50",
    d: "m0 86.036 8.922-.442-.436-4.267L0 81.748z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#365d61",
    d: "m0 84.75 8.791-.436-.218-2.134L0 82.605z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m41.346 87.1-.635.028.009.2a.22.22 0 0 1-.209.228l-.919.041a.22.22 0 0 1-.228-.208l-.009-.199-.635.03.009.198a.22.22 0 0 1-.209.228l-.919.042a.22.22 0 0 1-.228-.208l-.009-.199-.635.03.009.198a.22.22 0 0 1-.208.228l-.92.042a.22.22 0 0 1-.228-.208l-.009-.199-.635.029.01.199a.22.22 0 0 1-.21.228l-.918.042a.22.22 0 0 1-.228-.208l-.01-.2-.328.016-.19-4.169 8.292-.378Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.391 80.405a1.547 1.547 0 0 0-1.787-1.37l-3.107.505v5.75a2.317 2.317 0 0 0 2.07 2.306l3.6.398Z",
    opacity: 0.15
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#a59067",
    d: "m16.393 78.963-.836-1.025a1.25 1.25 0 0 0-1.077-.455l-8.773.773A1.25 1.25 0 0 0 4.568 79.5v5.79a1.25 1.25 0 0 0 1.114 1.24l8.375.906a1.25 1.25 0 0 1 .586.221l2.895 2.045a1.25 1.25 0 0 0 .594.222l6.143.623a1.25 1.25 0 0 0 1.322-.886l2.053-6.91a1.3 1.3 0 0 0 .052-.356v-3.417l-10.288.444a1.25 1.25 0 0 1-1.021-.459m5.225 8.015a2.236 2.236 0 0 1-2.388-1.981 3.29 3.29 0 0 1 2.795-2.667c1.179 0 1.735 1.317 1.735 2.506a2.14 2.14 0 0 1-2.142 2.142"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M29.34 84.95a.51.51 0 0 1-.453-.276c-.042-.08-1.431-2.075-.67-3.839.113-.259 2.435.386 2.221.57a2.76 2.76 0 0 0-.645 2.801.51.51 0 0 1-.453.744"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#a59067",
    d: "M63.152 78.7v3.116l-18.024.441a.6.6 0 0 0-.227.05l-5.463 2.368a.6.6 0 0 1-.451.013l-3.048-1.115a.61.61 0 0 0-.59.096l-1.62 1.3a.61.61 0 0 1-.868-.11l-1.805-2.397a.6.6 0 0 0-.403-.237l-2.951-.41V78.7Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m31.695 83.31-.629 1.596a.704.704 0 0 1-.718.442l-1.541-.14a.8.8 0 0 1-.494-.227l-1.028-1-.521 1.753.766.66a.8.8 0 0 0 .488.196l2.975.157a1.27 1.27 0 0 0 1.182-.666l.669-1.245ZM38.987 84.688l-.33-.12q-.002.054-.002.109a7.5 7.5 0 0 0 .363 2.072 7.3 7.3 0 0 0 .171-2.028.6.6 0 0 1-.202-.033M36.753 83.87q-.024.463-.01.923a7.5 7.5 0 0 0 .362 2.072 7.5 7.5 0 0 0 .172-2.096c-.015-.246-.046-.49-.075-.734ZM34.62 84.253c-.006.237-.015.473-.008.71a7.5 7.5 0 0 0 .362 2.071 7.5 7.5 0 0 0 .173-2.096 11 11 0 0 0-.106-1.022Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__i)",
    d: "m27.007 84.914.643-2.164a1.3 1.3 0 0 0 .052-.355v-2.88l-23.134 1.23v4.545a1.24 1.24 0 0 0 .3.8l14.404-.765a1.7 1.7 0 0 1-.042-.328 3.29 3.29 0 0 1 2.795-2.667c1.179 0 1.735 1.317 1.735 2.506a2 2 0 0 1-.025.252Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__j)",
    d: "m27.702 80.373-23.134 1.23v3.218l14.97-.796a3.4 3.4 0 0 1 2.487-1.695c.837 0 1.354.667 1.588 1.478l3.783-.201.254-.857a1.3 1.3 0 0 0 .052-.355v-.58l2.951.41a.6.6 0 0 1 .403.237l.8 1.063 10.69-.197 2.355-1.02a.6.6 0 0 1 .227-.05l18.024-.442v-1.443Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.152 78.7h-35.45v.278l-1.002.043a1.19 1.19 0 0 0 1.11.86l18.563.527a1.22 1.22 0 0 0 1.065-.632l15.714.27Z",
    opacity: 0.15
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#021819",
    d: "M34.336 74.272H42v2.156h-7.664z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "m89.54 79.43-43.274-.745a.14.14 0 0 1-.14-.142v-1.76a.14.14 0 0 1 .142-.142l43.275-.213a.14.14 0 0 1 .142.142v2.718a.14.14 0 0 1-.144.142"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m95.663 80.178-5.845-.409a.14.14 0 0 1-.133-.142v-3.5a.14.14 0 0 1 .135-.141l5.845-.306a.14.14 0 0 1 .15.141v4.215a.14.14 0 0 1-.152.142M25.81 74.709l5.424.41a.12.12 0 0 0 .13-.121v-3.146a.12.12 0 0 0-.13-.12l-5.424.41a.12.12 0 0 0-.112.12v2.326a.12.12 0 0 0 .112.12M45.522 74.68l2.632.922a.1.1 0 0 0 .047.008h7.872a.14.14 0 0 0 .142-.142v-4.086a.14.14 0 0 0-.142-.142h-7.872a.1.1 0 0 0-.047.008l-2.632.922a.14.14 0 0 0-.095.135v2.24a.14.14 0 0 0 .095.135"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.062,
    height: 2.442,
    x: 31.365,
    y: 72.204,
    fill: "#093a3e",
    rx: 0.133
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m46.37 79.338-18.53-.528a.14.14 0 0 1-.138-.142v-2.284a.14.14 0 0 1 .138-.142l18.53-.527a.14.14 0 0 1 .145.142v3.339a.14.14 0 0 1-.146.142"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.306 82.33c-.045 0-.094.016-.14.02 1.077.105 1.595 1.348 1.595 2.486a2.14 2.14 0 0 1-2.142 2.142 2.27 2.27 0 0 1-2.37-1.833c-.003.04-.019.08-.019.12a2.46 2.46 0 0 0 2.628 2.18 2.356 2.356 0 0 0 2.357-2.357c0-1.308-.612-2.758-1.909-2.758",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__k)",
    d: "m67.594 79.052 8.886.153a2.5 2.5 0 0 1 .56-2.715l-8.006.04c.247.177.437.35.454.502.086.792-.86 1.444-1.894 2.02",
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lang_kurz-waffen_svg__l)",
    d: "M39.75 79.15a3.21 3.21 0 0 1 .21-3.253l-4.056.116c.785.757 1.868 2.025 1.642 3.074Z",
    opacity: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#55767a",
    d: "m25.698 73.644 5.667.201v-.84l-5.667.201z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f7e82",
    d: "m25.698 73.495 5.667.134v-.407l-5.667.133z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#55767a",
    d: "m45.427 74.343 10.788.382v-2.6l-10.788.382z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f7e82",
    d: "m45.427 73.961 10.788.254v-1.58l-10.788.255z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "M32.564 76.907c2.257-.174 4.518-.246 6.777-.326 2.261-.05 4.522-.107 6.786-.06-2.258.176-4.518.247-6.778.327-2.26.049-4.521.105-6.785.06"
  }))));
};
export default SvgLangKurzWaffen;